import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userSearch'
})
@Injectable()
export class UsersearchPipe implements PipeTransform {
  transform(members: any[], search: string): any {
    if (!members) {
      return;
    } else if (!search) {
      return members;
    } else {
      console.log(search);
      let term = search.toLowerCase();
      return members.filter(members => members.name.toLowerCase().indexOf(term) > -1 || members.firstname.toLowerCase().indexOf(term) > -1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/usersearch/usersearch.ts